import React from "react"
import SpecialProductCarousel from '../../components/SpecialProductCarousel'

const SpecialProductSection = ({data}) => {
  return (
    <SpecialProductCarousel data={data} />
  )
}

export default SpecialProductSection